@if (reviews()) {
<nb-list>
  @for (hw of reviews().homework; track $index; let i = $index) {
  <nb-list-item class="border-0 px-0">
    <label class="fw-bold mb-2" [innerHTML]="hw.label"></label>
    <p [innerHTML]="hw.value"></p>
    @for (pr of reviews().reviews; track $index;let j = $index) {
    <blockquote class="blockquote">
      @if (pr && pr.type != 'none') {
      <div
        class="callout ms-2"
        [class.callout-basic]="j == 0"
        [class.callout-info]="j == 1"
        [class.callout-primary]="j == 2"
      >
        <p [innerHTML]="pr.value"></p>
      </div>
      }
    </blockquote>
    }
  </nb-list-item>
  }
</nb-list>
} @else if (reviewResultResource.error()) {
<nb-alert outline="danger" class="w-100">{{
  reviewResultResource.error()
}}</nb-alert>
}
